import React from 'react';
import { connect } from 'react-redux';
import Moment from '../../../components/utils/Moment';
import moment from 'moment';
import { requestAdvocate } from '../../../store/advocate-dashboard/AdvocateActions';

class AdvocateCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = { info: {}, remoteInfo: null };
  }

  componentWillMount() {
    const { id, getAdvocate, info } = this.props;
    if (id) {
      getAdvocate(id);
      this.setState({ id });
    }
    if (info) {
      this.setState({
        info,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { advocate } = nextProps;
    const { id } = this.state;
    if (advocate[id]) {
      this.setState({ remoteInfo: advocate[id] });
    }
  }

  render() {
    const { info: tagInfo } = this.props;
    const { remoteInfo } = this.state;

    let info = {};
    if (remoteInfo) {
      info = remoteInfo;
    }
    if (tagInfo) {
      info = tagInfo;
    }
    //const alerts = getAlerts(info, limits);
    return info.patientId ? (
      <div className="visit-note-cell" ref={info.patientId}>
        <div className="row">
          <div className="col-sm-9">
            <span className="review-label">Name</span>
            <br />
            <strong>{info.firstName} {info.lastName}</strong>{' '}
          </div>
          <div className="col-sm-3">
            <span className="review-label">Athena ID</span>
            <br />
            {/*<a href={`https://www.app.elationemr.com/patient/${info.athenaID}/`} target="_blank">{info.athenaID}</a>*/}
            <a href={`https://athenanet.athenahealth.com/23284/1/globalframeset.esp?&MAIN=clinicals%2Fcharttabs.esp%3FPATIENTID%3D${info.athenaID}`} target="_blank">{info.athenaID}</a>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-4">
            <span className="review-label">DOB</span>
            <br />
            <Moment date={info.DOB} format="MM/DD/YYYY" />
          </div>
          <div className="col-sm-4">
            <span className="review-label">Age</span>
            <br />
            {info.age}
          </div>
          <div className="col-sm-4">
            <span className="review-label">Gender</span>
            <br />
            {info.gender}
          </div>

        </div>
        <div className="row">
          <div className="col-sm-4">
            <span className="review-label">Visits (12 mos.)</span>
            <br />
            {info.visitsLast12}
          </div>
          <div className="col-sm-4">
            <span className="review-label">Last Visit</span>
            <br />
            {(info.lastVisit !== null) ? (info.lastVisit === "") ? '' : <Moment date={info.lastVisit} format="MM/DD/YYYY" /> : '' }
          </div>
          <div className="col-sm-4">
            <span className="review-label">Next Visit</span>
            <br />
            {(info.nextVisitDate !== null) ? (info.nextVisitDate === "") ? '' : <Moment date={info.nextVisitDate} format="MM/DD/YYYY" /> : ''}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <span className="review-label">Risk Category</span>
            <br />
            {info.riskCategory}
          </div>
          <div className="col-sm-6">
            <span className="review-label">Risk Engaged</span>
            <br />
            {info.riskEngaged}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-4">
            <span className="review-label">Last Outreach</span>
            <br />
            {(info.lastOutreachDate !== null) &&
              <span id={`lastOutreachDate_${info.patientId}`}>{
                moment(info.lastOutreachDate).format("MM/DD/YYYY" || 'llll')}</span>
            }
          </div>
          <div className="col-sm-4">
            <span className="review-label">Follow Up Date</span>
            <br />
            {(info.nextFlowUpAt !== null) &&
              <span id={`nextFlowUpAt_${info.patientId}`}>{
                moment(info.nextFlowUpAt).format("MM/DD/YYYY" || 'llll')}</span>
            }
          </div>
          <div className="col-sm-4">
            <span className="review-label">HCC</span>
            <br />
            {(info.HCCFlag === 1) ? <span>YES</span> : <span>NO</span>}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 flags">
            <span className="review-label">Clinical Flags</span>
            <br />
            &nbsp;
            {info.PreDFlag === 1 && (
              <span title="PreDiabetes" className="label label-danger">PRED</span>
            )}
            {info.DIAFlag === 1 && (
              <span title="Diabetes" className="label label-warning">DIAB</span>
            )}
            {info.HTNFlag === 1 && (
              <span title="Hypertension" className="label" style={{ backgroundColor: 'blue' }}>HYPT</span>
            )}
            {info.HLDFlag === 1 && (
              <span title="Hyperlipidemia" className="label" style={{ backgroundColor: 'green' }}>HYPL</span>
            )}
            {info.AsthmaFlag === 1 && (
              <span title="Asthma" className="label" style={{ backgroundColor: 'pink' }}>ASTH</span>
            )}
            {info.ObesityFlag === 1 && (
              <span title="Obesity" className="label" style={{ backgroundColor: '#8f6900' }}>OBES</span>
            )}
            &nbsp;
            </div>
        </div>
      </div>
    ) : (
      <div className="spinner"></div>
    );
  }
}

export default connect(
  state => ({
    advocate: state.advocates.advocate
  }),
  dispatch => ({
    getAdvocate: id => dispatch(requestAdvocate(id)),
  }),
  null,
  { withRef: true }
)(AdvocateCard);



// WEBPACK FOOTER //
// ./src/routes/management/components/AdvocateCard.js